import { render, staticRenderFns } from "./RubricPreview.vue?vue&type=template&id=740baaff&scoped=true"
import script from "./RubricPreview.vue?vue&type=script&lang=js"
export * from "./RubricPreview.vue?vue&type=script&lang=js"
import style0 from "./RubricPreview.vue?vue&type=style&index=0&id=740baaff&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740baaff",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('740baaff')) {
      api.createRecord('740baaff', component.options)
    } else {
      api.reload('740baaff', component.options)
    }
    module.hot.accept("./RubricPreview.vue?vue&type=template&id=740baaff&scoped=true", function () {
      api.rerender('740baaff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/infra/rubricSetting/Preview/RubricPreview.vue"
export default component.exports